<div class="saved-search-rules-selection">
    <!-- Rule List -->
    <ng-container *ngFor="let rule of ruleList; let i = index;">
        <div class="p-grid">
            <div class="p-col-12 p-lg-2">
                <ng-container *ngIf="i > 0 || ruleData.length > 0">
                    <label>Choice</label>
                    <p-dropdown appendTo="body"
                        [options]="choicesDD" optionLabel="name"
                        [(ngModel)]="rule.choice" placeholder="Select Choice"
                        [filter]="true" [resetFilterOnHide]="true"
                        (onChange)="selectChoice($event)">
                    </p-dropdown>
                </ng-container>
            </div>
            <div *ngIf="!filterTreeView" class="p-col-12 p-lg-3">
                <label>Filter</label>
                <p-dropdown appendTo="body" [options]="rule.filtersDD" scrollHeight="300px" id="ruleFilter" name="ruleFilter" optionLabel="labelname" placeholder="Select Filter" [(ngModel)]="rule.filter" [filter]="true" [resetFilterOnHide]="true" (onChange)="onFieldChangeRuleList(rule)">
                    <ng-template let-target pTemplate="item">
                        <div class="ui-helper-clearfix" pTooltip="{{target.tooltip}}" tooltipPosition="top">
                            <span>{{target.labelname}}</span>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
            <div *ngIf="filterTreeView" class="p-col-12 p-lg-3">
                <label>Filter</label>
                <liono-treeSelect
                    [options]="rule.filtersDDTree"
                    [filter]="true"
                    filterPlaceholder="Search Fields..."
                    placeholder="Select a field"
                    appendTo="body"
                    [(ngModel)]="rule.filter"
                    [scrollHeight]="'285px'"
                    (onNodeSelect)="onFieldChangeRuleList(rule)">
                </liono-treeSelect>
                <small *ngIf="rule?.errorMsg" style="color: red;" [ngClass]="{'main-module-rule-error': isMainModule }" class="saved-search-rule-error">{{rule?.errorMsg}}</small>
            </div>
            <div class="p-col-12 p-lg-2">
                <label>Operator</label>
                <p-dropdown appendTo="body" [options]="rule.filter.operatorsDD" optionLabel="name" [(ngModel)]="rule.operator" placeholder="select" (onChange)="onOperatorChangeRuleList(rule)">
                </p-dropdown>
            </div>
            <div class="p-col-12 p-lg-4">
                <label>Value</label>
                <!-- String -->
                <ng-container *ngIf="rule.filter?.fieldDataType == 'String'">
                    <input *ngIf="rule.filter?.valueDataType == 'String'" pInputText type="text" [(ngModel)]="rule.value" placeholder="Enter" [disabled]="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'">
                    <!-- Value2 -->
                    <!-- <input pInputText type="text" [(ngModel)]="rule.value2" placeholder="Enter"
                        *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'"> -->
                    <p-multiSelect *ngIf="rule.filter?.valueDataType == 'User'" appendTo="body" [options]="users" [(ngModel)]="rule.value" optionLabel="name" placeholder="Select Users">
                    </p-multiSelect>
                    <!-- Year -->
                    <ng-container *ngIf="rule.filter?.valueDataType == 'Year'">
                        <p-calendar view="year" dateFormat="yy" placeholder="yyyy" appendTo="body" [(ngModel)]="rule.value">
                        </p-calendar>
                    </ng-container>
                    <!-- AutoCompleteDropdown -->
                    <ng-container *ngIf="rule.filter?.valueDataType == 'AutoCompleteDropdown' && (multiSelectFieldsNS.AutoCompleteDropdownFieldsArray.includes(rule.filter?.field?.toLowerCase()))">
                        <p-autoComplete *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed != 'No_Value'" #parent [suggestions]="rule.valueLists" [(ngModel)]="rule.value" name="parent" placeholder="Search..." field="name" [completeOnFocus]="true" (completeMethod)="searchAutocompleteItems($event, 'List', rule, rule.filter,true)"
                            id="parent" appendTo="body" dataKey="id" inputId="parent" name="selectedParentAccount" [multiple]="true" [ngModelOptions]="{standalone: true}" styleClass="p-d-block">
                            <ng-template let-obj pTemplate="item">
                                {{(obj?.label||obj.name) | shorten:60}}
                            </ng-template>
                        </p-autoComplete>

                        <input *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'" pInputText type="text" [(ngModel)]="rule.value" placeholder="Enter" [disabled]="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'">
                    </ng-container>

                    <ng-container *ngIf="rule.filter?.valueDataType == 'AutoCompleteDropdown' && (multiSelectFieldsNS.AutoCompleteProductFieldsArray.includes(rule.filter?.field?.toLowerCase()))">
                        <p-autoComplete *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed != 'No_Value'" #parent [suggestions]="rule.valueLists" [(ngModel)]="rule.value" name="parent" placeholder="Search..." field="item2" [completeOnFocus]="true" (completeMethod)="searchAllProductAutoComplateData($event, 'List', rule)"
                            id="parent" appendTo="body" dataKey="id" inputId="parent" name="selectedParentAccount" [ngModelOptions]="{standalone: true}">
                            <ng-template let-obj pTemplate="item">
                                {{obj.item2 | shorten:30}} {{obj.item3 | shorten:30}}
                            </ng-template>
                        </p-autoComplete>

                        <input *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'" pInputText type="text" [(ngModel)]="rule.value" placeholder="Enter" [disabled]="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'">
                    </ng-container>

                </ng-container>
                <!-- Number -->
                <ng-container *ngIf="rule.filter?.fieldDataType == 'Number'">
                    <ng-container *ngIf="rule.filter?.valueDataType == 'Number'">
                        <div [ngClass]="{'input-dropdown-wrapper': !rule?.compareWithField}">
                            <input *ngIf="!rule?.compareWithField" pInputText type="number" [(ngModel)]="rule.value" placeholder="Enter" [disabled]="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'">
                            <!-- Value2 -->
                            <input pInputText type="number" [(ngModel)]="rule.value2" placeholder="Enter" *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'">
                            <p-dropdown
                                *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value'"
                                pTooltip="Compare with another field" tooltipPosition="top"
                                [filter]="true"
                                [showClear]="true"
                                appendTo="body"
                                [options]="availableCompareFields"
                                optionLabel="labelname" optionValue="criteria"
                                [(ngModel)]="rule.comparisonCriteria"
                                (onChange)="onCompareFieldChange(rule)"
                                placeholder="Select Field">
                                <ng-template let-item pTemplate="selectedItem">
                                    {{ item?.parentLabelName ? item?.parentLabelName + ': ' : ''}}{{item.labelname}}
                                </ng-template>
                                <ng-template let-item pTemplate="item">
                                    {{ item?.parentLabelName ? item?.parentLabelName + ': ' : ''}}{{item.labelname}}
                                </ng-template>
                            </p-dropdown>
                        </div>
                    </ng-container>
                </ng-container>
                <!-- Decimal -->
                <ng-container *ngIf="rule.filter?.fieldDataType == 'Decimal'">
                    <ng-container *ngIf="rule.filter?.valueDataType == 'Decimal'">
                        <div [ngClass]="{'input-dropdown-wrapper': !rule?.compareWithField}">
                            <p-inputNumber
                                *ngIf="!rule?.compareWithField"
                                [(ngModel)]="rule.value" placeholder="Enter"
                                [disabled]="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'"
                                [minFractionDigits]="0" [maxFractionDigits]="(rule.filter?.maxLengthAfterDecimal||6)">
                            </p-inputNumber>
                            <!-- Value2 -->
                            <p-inputNumber
                                *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'"
                                [(ngModel)]="rule.value2" placeholder="Enter"
                                [minFractionDigits]="0" [maxFractionDigits]="(rule.filter?.maxLengthAfterDecimal||6)">
                            </p-inputNumber>
                            <p-dropdown
                                *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value'"
                                pTooltip="Compare with another field" tooltipPosition="top"
                                [filter]="true"
                                [showClear]="true"
                                appendTo="body"
                                [options]="availableCompareFields"
                                optionLabel="labelname" optionValue="criteria"
                                [(ngModel)]="rule.comparisonCriteria"
                                (onChange)="onCompareFieldChange(rule)"
                                placeholder="Select Field">
                                <ng-template let-item pTemplate="selectedItem">
                                    {{ item?.parentLabelName ? item?.parentLabelName + ': ' : ''}}{{item.labelname}}
                                </ng-template>
                                <ng-template let-item pTemplate="item">
                                    {{ item?.parentLabelName ? item?.parentLabelName + ': ' : ''}}{{item.labelname}}
                                </ng-template>
                            </p-dropdown>
                        </div>
                    </ng-container>
                </ng-container>
                <!-- Money -->
                <ng-container *ngIf="rule.filter?.fieldDataType == 'Money'">
                    <ng-container *ngIf="rule.filter?.valueDataType == 'Number'">
                        <div [ngClass]="{'input-dropdown-wrapper': !rule?.compareWithField}">
                            <input  *ngIf="!rule?.compareWithField" pInputText type="number" [(ngModel)]="rule.value" placeholder="Enter" [disabled]="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'">
                            <!-- Value2 -->
                            <input pInputText type="number" [(ngModel)]="rule.value2" placeholder="Enter" *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'">
                            <p-dropdown
                                *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value'"
                                pTooltip="Compare with another field" tooltipPosition="top"
                                [filter]="true"
                                [showClear]="true"
                                appendTo="body"
                                [options]="availableCompareFields"
                                optionLabel="labelname" optionValue="criteria"
                                [(ngModel)]="rule.comparisonCriteria"
                                (onChange)="onCompareFieldChange(rule)"
                                placeholder="Select Field">
                                <ng-template let-item pTemplate="selectedItem">
                                    {{ item?.parentLabelName ? item?.parentLabelName + ': ' : ''}}{{item.labelname}}
                                </ng-template>
                                <ng-template let-item pTemplate="item">
                                    {{ item?.parentLabelName ? item?.parentLabelName + ': ' : ''}}{{item.labelname}}
                                </ng-template>
                            </p-dropdown>
                        </div>
                    </ng-container>
                </ng-container>
                <!-- Distance -->
                <ng-container *ngIf="rule.filter?.fieldDataType == 'Distance'">
                    <div class="p-grid">
                        <div class="p-col-12 p-lg-4 p-pr-0">
                            <input pTooltip="Address" tooltipPosition="top" pInputText type="text" [value]="rule.value?.address ?? ''" [disabled]="true">
                        </div>
                        <div class="p-col-12 p-lg-3">
                            <input pTooltip="Radius" tooltipPosition="top" pInputText type="text" [value]="rule.value?.radius ?? ''" [disabled]="true">
                        </div>
                        <div class="p-col-12 p-lg-5 p-px-0">
                            <button type="button" (click)="openAddressSelect('List')" pButton label="Select address" class="p-button" style="white-space: nowrap;"></button>
                        </div>
                    </div>
                </ng-container>
                <!-- Boolean -->
                <ng-container *ngIf="rule.filter?.fieldDataType == 'Boolean'">
                    <p-dropdown appendTo="body" [options]="booleanValueDD" optionLabel="name" [(ngModel)]="rule.value" placeholder="select">
                    </p-dropdown>
                </ng-container>
                <!-- Enum -->
                <ng-container *ngIf="rule.filter?.fieldDataType == 'Enum'">
                    <ng-container *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'">
                        <input pInputText type="text" [(ngModel)]="rule.value" placeholder="Enter" [disabled]="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'" />
                    </ng-container>
                    <ng-container *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed != 'No_Value'">
                        <input *ngIf="rule.filter?.valueDataType == 'String'" pInputText type="text" [(ngModel)]="rule.value" placeholder="Enter" />
                        <!-- <input pInputText type="text" [(ngModel)]="rule.value2" placeholder="Enter"
                        *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'"/> -->
                        <p-multiSelect *ngIf="rule.filter?.valueDataType == 'User'" appendTo="body" [options]="users" [(ngModel)]="rule.value" optionLabel="name" placeholder="Select Users">
                        </p-multiSelect>
                        <!-- Country -->
                        <ng-container *ngIf="rule.filter?.valueDataType == 'Country'">
                            <!-- <liono-treeSelect [(ngModel)]="rule.value" selectionMode="multiple" display="nodes" optionLabel="name"
                            selectionMode="checkbox" [options]="nodes" appendTo="body" scrollHeight="300px"
                            [options]="allCountryList" placeholder="Select Items" [filter]="true" [resetFilterOnHide]="true">
                        </liono-treeSelect> -->
                            <p-dropdown appendTo="body" [options]="allCountryList" optionLabel="name" [(ngModel)]="rule.value" [filter]="true" [resetFilterOnHide]="true" placeholder="Select Items" (onChange)="onValueChangeRuleList(rule)">
                            </p-dropdown>
                        </ng-container>
                        <!-- DropdownList -->
                        <ng-container *ngIf="rule.filter?.valueDataType == 'DropdownList'">
                            <p-dropdown appendTo="body" [options]="rule.valueLists" optionLabel="name" [(ngModel)]="rule.value" [filter]="true" [resetFilterOnHide]="true" placeholder="Select Item">
                            </p-dropdown>
                        </ng-container>
                        <!-- MultiSelect -->
                        <ng-container *ngIf="rule.filter?.valueDataType == 'MultiSelect'">
                            <p-multiSelect appendTo="body" [options]="rule.valueLists" [(ngModel)]="rule.value" optionLabel="name" [optionGroupLabel]="rule?.groupLabel" [optionGroupChildren]="rule?.groupChildren" [group]="rule?.group" placeholder="Select Items" (onChange)="onChangeRuleFieldValue(rule)">
                                <ng-template let-obj pTemplate="selectedItem">
                                    <span pTooltip="{{obj.name}}" tooltipPosition="top">
                                        {{ (obj.name.length>40)? (obj.name | slice:0:40)+'..':(obj.name) }}
                                    </span>
                                </ng-template>
                            </p-multiSelect>
                        </ng-container>
                        <!-- MultiSelectAPI -->
                        <ng-container *ngIf="rule.filter?.valueDataType == 'MultiSelectAPI'">
                            <p-multiSelect appendTo="body" [lazy]="true" (onFilter)="searchAutocompleteItems($event, 'List', rule, rule.filter)" [options]="rule.valueLists" [(ngModel)]="rule.value" optionLabel="name" placeholder="Search Items">
                                <ng-template let-obj pTemplate="selectedItem">
                                    <span pTooltip="{{obj.name}}" tooltipPosition="top">
                                        {{ (obj.name.length>40)? (obj.name | slice:0:40)+'..':(obj.name) }}
                                    </span>
                                </ng-template>
                            </p-multiSelect>
                        </ng-container>
                        <!-- TreeSelect -->
                        <ng-container *ngIf="rule.filter?.valueDataType == 'TreeSelect' && rule.filter?.field?.toLowerCase()=='territoryname'">
                            <liono-treeSelect [(ngModel)]="rule.value" [options]="territory" appendTo="body" placeholder="Select Territory" (onNodeExpand)="onNodeExpand($event)" (onNodeSelect)="onChangeAssign($event)" [filter]="true" [filterInputAutoFocus]="true" selectionMode="single">
                            </liono-treeSelect>
                        </ng-container>
                        <ng-container *ngIf="rule.filter?.valueDataType == 'TreeSelect' && rule.filter?.field?.toLowerCase()!='territoryname'">
                            <liono-treeSelect [(ngModel)]="rule.value" [options]="rule.treeValueLists" appendTo="body" placeholder="Select Item" [filter]="true" [metaKeySelection]="false" selectionMode="multiple" display="comma">
                            </liono-treeSelect>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <!-- DateTime -->
                <ng-container *ngIf="rule.filter?.fieldDataType == 'DateTime'">
                    <p-dropdown *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value' && rule.dataTypeWithOperator?.Operator == 'Is'" [options]="dateTimeOperatorValue" id="code" [style]="{'width':'100%'}" (onChange)="dateTimeOperatorValueChange()" [(ngModel)]="rule.value2"
                        optionLabel="label" appendTo="body" placeholder="Select Value">
                    </p-dropdown>
                    <p-calendar *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value' && (rule.dataTypeWithOperator?.Operator != 'Is' || (rule.dataTypeWithOperator?.Operator == 'Is' && rule.value2?.code == 'custom'))" appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy"
                        yearRange="1900:2100" [ngModelOptions]="{standalone: true}" [(ngModel)]="rule.value" [disabled]="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'">
                    </p-calendar>
                    <p-calendar *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'" appendTo="body" selectionMode="range" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy to mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                        [ngModelOptions]="{standalone: true}" [(ngModel)]="rule.value">
                    </p-calendar>
                </ng-container>

                <!-- Time -->
                <ng-container *ngIf="rule.filter?.fieldDataType == 'Time'">
                    <div class="p-d-flex p-ai-center">
                        <input pInputText type="time" [(ngModel)]="rule.value" class="w-100">
                        <input *ngIf="rule.dataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'"  pInputText type="time" [(ngModel)]="rule.value2" class="w-100">
                    </div>
                </ng-container>

                <!-- When filter not selected -->
                <ng-container *ngIf="!rule?.filter?.fieldDataType">
                    <input pInputText type="text" placeholder="Enter" [disabled]="true" />
                </ng-container>

                <small *ngIf="rule?.ruleErrorMsg" style="color: red;" [ngClass]="{'main-module-rule-error': isMainModule }" class="saved-search-rule-error">{{rule?.ruleErrorMsg}}</small>
            </div>
            <div class="p-col-12 p-lg-1 p-mt-5">
                <div class="btnBars p-mr-0" (click)="removeList(i)" style="float: right;">
                    <i class="pi pi-minus"></i>
                </div>
            </div>
        </div>
    </ng-container>

    <hr *ngIf="ruleList.length > 0">

    <!-- New Rule -->
    <div class="p-grid">
        <div class="p-col-12 p-lg-2">
            <ng-container *ngIf="((ruleList.length > 0 || ruleData.length > 0) && !editRule) || (editRule && (ruleList.length > 1 || ruleData.length > 1))">
                <label>Choice</label>
                <p-dropdown appendTo="body"
                    [options]="choicesDD" optionLabel="name"
                    [(ngModel)]="lastRuleValues.selectedChoice"
                    placeholder="Select Choice" [filter]="true"
                    [resetFilterOnHide]="true"
                    (onChange)="selectChoice($event)">
                </p-dropdown>
            </ng-container>
        </div>
        <div *ngIf="!filterTreeView" class="p-col-12 p-lg-3">
            <label>Filter</label>
            <p-dropdown appendTo="body" [options]="lastRuleValues.filtersDD" scrollHeight="300px" id="ruleFilter" name="ruleFilter" optionLabel="labelname" placeholder="Select Filter" [(ngModel)]="lastRuleValues.selectedFilter" [filter]="true" [resetFilterOnHide]="true" (onChange)="onFieldChange(lastRuleValues.selectedFilter, null)">
                <ng-template let-target pTemplate="item">
                    <div class="ui-helper-clearfix" pTooltip="{{target.tooltip}}" tooltipPosition="top">
                        <span>{{target.labelname}}</span>
                    </div>
                </ng-template>
            </p-dropdown>
        </div>
        <div *ngIf="filterTreeView" class="p-col-12 p-lg-3">
            <label>Filter</label>
            <liono-treeSelect
                [options]="lastRuleValues.filtersDDTree"
                [filter]="true"
                filterPlaceholder="Search Fields..."
                placeholder="Select a field"
                appendTo="body"
                [(ngModel)]="lastRuleValues.selectedFilter"
                [scrollHeight]="'285px'"
                (onNodeSelect)="onFieldChange(lastRuleValues.selectedFilter, null)">
            </liono-treeSelect>
            <small *ngIf="selectedFieldErrorMsg" style="color: red;" [ngClass]="{'main-module-rule-error': isMainModule }" class="saved-search-rule-error">{{selectedFieldErrorMsg}}</small>
        </div>
        <div class="p-col-12 p-lg-2">
            <label>Operator</label>
            <p-dropdown appendTo="body" [options]="lastRuleValues.selectedFilter?.operatorsDD" optionLabel="name" [(ngModel)]="lastRuleValues.selectedOperator" placeholder="select" (onChange)="onOperatorChange(lastRuleValues.selectedFilter)">
            </p-dropdown>
        </div>
        <div class="p-col-12" [ngClass]="{'p-lg-4': !editRule, 'p-lg-5': editRule}">
            <label>Value</label>
            <!-- String -->
            <ng-container *ngIf="lastRuleValues.selectedFilter?.fieldDataType == 'String'">
                <input *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'String'" pInputText type="text" [(ngModel)]="lastRuleValues.selectedValue" placeholder="Enter" [disabled]="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'" />
                <!-- <input pInputText type="text" [(ngModel)]="lastRuleValues.selectedValue2" placeholder="Enter"
                    *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'"/> -->
                <p-multiSelect *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'User'" appendTo="body" [options]="users" [(ngModel)]="lastRuleValues.selectedValue" optionLabel="name" placeholder="Select Users">
                </p-multiSelect>
                <!-- Year -->
                <ng-container *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'Year'">
                    <p-calendar view="year" dateFormat="yy" placeholder="yyyy" appendTo="body" [(ngModel)]="lastRuleValues.selectedValue">
                    </p-calendar>
                </ng-container>
                <!-- AutoCompleteDropdown -->
                <ng-container *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'AutoCompleteDropdown' && (multiSelectFieldsNS.AutoCompleteDropdownFieldsArray.includes(lastRuleValues.selectedFilter?.field?.toLowerCase()))">
                    <p-autoComplete *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed != 'No_Value'" #parent [suggestions]="lastRuleValues.allEnumMultiselect" [(ngModel)]="lastRuleValues.selectedValue" name="parent" placeholder="Search..." field="name" [completeOnFocus]="true" (completeMethod)="searchAutocompleteItems($event, 'Selected', null, lastRuleValues.selectedFilter,true)"
                        id="parent" appendTo="body" dataKey="id" inputId="parent" name="selectedParentAccount" [multiple]="true" [ngModelOptions]="{standalone: true}" styleClass="p-d-block">
                        <ng-template let-obj pTemplate="item">
                            {{(obj?.label||obj.name) | shorten:60}}
                        </ng-template>
                    </p-autoComplete>

                    <input *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'" pInputText type="text" [(ngModel)]="lastRuleValues.selectedValue" placeholder="Enter" [disabled]="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'" />
                </ng-container>

                <ng-container *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'AutoCompleteDropdown' && (multiSelectFieldsNS.AutoCompleteProductFieldsArray.includes(lastRuleValues.selectedFilter?.field?.toLowerCase()))">
                    <p-autoComplete *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed != 'No_Value'" #parent [suggestions]="lastRuleValues.allEnumMultiselect" [(ngModel)]="lastRuleValues.selectedValue" name="parent" placeholder="Search..." field="item2" [completeOnFocus]="true" (completeMethod)="searchAllProductAutoComplateData($event, 'Selected', null,lastRuleValues.selectedFilter?.field)"
                        id="parent" appendTo="body" dataKey="id" inputId="parent" name="selectedParentAccount" [ngModelOptions]="{standalone: true}">
                        <ng-template let-obj pTemplate="item">
                            {{obj.item2 | shorten:30}} {{obj.item3 | shorten:30}}
                        </ng-template>
                    </p-autoComplete>

                    <input *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'" pInputText type="text" [(ngModel)]="lastRuleValues.selectedValue" placeholder="Enter" [disabled]="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'" />
                </ng-container>

            </ng-container>
            <!-- Number -->
            <ng-container *ngIf="lastRuleValues.selectedFilter?.fieldDataType == 'Number'">
                <ng-container *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'Number'">
                    <div [ngClass]="{'input-dropdown-wrapper': !lastRuleValues?.compareWithField}">
                        <input *ngIf="!lastRuleValues?.compareWithField" pInputText type="number" [(ngModel)]="lastRuleValues.selectedValue" placeholder="Enter" [disabled]="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'">
                        <!-- Value2 -->
                        <input pInputText type="number" [(ngModel)]="lastRuleValues.selectedValue2" placeholder="Enter" *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'">
                        <p-dropdown
                            *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value'"
                            pTooltip="Compare with another field" tooltipPosition="top"
                            [filter]="true"
                            [showClear]="true"
                            appendTo="body"
                            [options]="availableCompareFields"
                            optionLabel="labelname" optionValue="criteria"
                            [(ngModel)]="lastRuleValues.comparisonCriteria"
                            (onChange)="onCompareFieldChange(lastRuleValues)"
                            placeholder="Select Field">
                            <ng-template let-item pTemplate="selectedItem">
                                {{ item?.parentLabelName ? item?.parentLabelName + ': ' : ''}}{{item.labelname}}
                            </ng-template>
                            <ng-template let-item pTemplate="item">
                                {{ item?.parentLabelName ? item?.parentLabelName + ': ' : ''}}{{item.labelname}}
                            </ng-template>
                        </p-dropdown>
                    </div>
                </ng-container>
            </ng-container>
            <!-- Decimal -->
            <ng-container *ngIf="lastRuleValues.selectedFilter?.fieldDataType == 'Decimal'">
                <ng-container *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'Decimal'">
                    <div [ngClass]="{'input-dropdown-wrapper': !lastRuleValues?.compareWithField}">
                        <p-inputNumber
                            *ngIf="!lastRuleValues?.compareWithField"
                            [(ngModel)]="lastRuleValues.selectedValue" placeholder="Enter"
                            [disabled]="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'"
                            [minFractionDigits]="0" [maxFractionDigits]="(lastRuleValues.selectedFilter?.maxLengthAfterDecimal||6)">
                        </p-inputNumber>
                        <!-- Value2 -->
                        <p-inputNumber
                            *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'"
                            [(ngModel)]="lastRuleValues.selectedValue2" placeholder="Enter"
                            [minFractionDigits]="0" [maxFractionDigits]="(lastRuleValues.selectedFilter?.maxLengthAfterDecimal||6)">
                        </p-inputNumber>
                        <p-dropdown
                            *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value'"
                            pTooltip="Compare with another field" tooltipPosition="top"
                            [filter]="true"
                            [showClear]="true"
                            appendTo="body"
                            [options]="availableCompareFields"
                            optionLabel="labelname" optionValue="criteria"
                            [(ngModel)]="lastRuleValues.comparisonCriteria"
                            (onChange)="onCompareFieldChange(lastRuleValues)"
                            placeholder="Select Field">
                            <ng-template let-item pTemplate="selectedItem">
                                {{ item?.parentLabelName ? item?.parentLabelName + ': ' : ''}}{{item.labelname}}
                            </ng-template>
                            <ng-template let-item pTemplate="item">
                                {{ item?.parentLabelName ? item?.parentLabelName + ': ' : ''}}{{item.labelname}}
                            </ng-template>
                        </p-dropdown>
                    </div>
                </ng-container>
            </ng-container>
            <!-- Money -->
            <ng-container *ngIf="lastRuleValues.selectedFilter?.fieldDataType == 'Money'">
                <ng-container *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'Number'">
                    <div [ngClass]="{'input-dropdown-wrapper': !lastRuleValues?.compareWithField}">
                        <input  *ngIf="!lastRuleValues?.compareWithField" pInputText type="number" [(ngModel)]="lastRuleValues.selectedValue" placeholder="Enter" [disabled]="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'">
                        <!-- Value2 -->
                        <input pInputText type="number" [(ngModel)]="lastRuleValues.selectedValue2" placeholder="Enter" *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'">
                        <p-dropdown
                            *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value'"
                            pTooltip="Compare with another field" tooltipPosition="top"
                            [filter]="true"
                            [showClear]="true"
                            appendTo="body"
                            [options]="availableCompareFields"
                            optionLabel="labelname" optionValue="criteria"
                            [(ngModel)]="lastRuleValues.comparisonCriteria"
                            (onChange)="onCompareFieldChange(lastRuleValues)"
                            placeholder="Select Field">
                            <ng-template let-item pTemplate="selectedItem">
                                {{ item?.parentLabelName ? item?.parentLabelName + ': ' : ''}}{{item.labelname}}
                            </ng-template>
                            <ng-template let-item pTemplate="item">
                                {{ item?.parentLabelName ? item?.parentLabelName + ': ' : ''}}{{item.labelname}}
                            </ng-template>
                        </p-dropdown>
                    </div>
                </ng-container>
            </ng-container>
            <!-- Distance -->
            <ng-container *ngIf="lastRuleValues.selectedFilter?.fieldDataType == 'Distance'">
                <div class="p-grid">
                    <div class="p-col-12 p-lg-4 p-pr-0">
                        <input pTooltip="Address" tooltipPosition="top" pInputText type="text" [value]="lastRuleValues.selectedValue?.address ?? ''" [disabled]="true">
                    </div>
                    <div class="p-col-12 p-lg-3">
                        <input pTooltip="Radius" tooltipPosition="top" pInputText type="text" [value]="lastRuleValues.selectedValue?.radius ?? ''" [disabled]="true">
                    </div>
                    <div class="p-col-12 p-lg-5 p-px-0">
                        <button type="button" (click)="openAddressSelect('Add')" pButton label="Select address" class="p-button" style="white-space: nowrap;"></button>
                    </div>
                </div>
            </ng-container>
            <!-- Boolean -->
            <ng-container *ngIf="lastRuleValues.selectedFilter?.fieldDataType == 'Boolean'">
                <p-dropdown appendTo="body" [options]="booleanValueDD" optionLabel="name" [(ngModel)]="lastRuleValues.selectedValue" placeholder="select">
                </p-dropdown>
            </ng-container>
            <!-- Enum -->
            <ng-container *ngIf="lastRuleValues.selectedFilter?.fieldDataType == 'Enum'">
                <ng-container *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'">
                    <input pInputText type="text" [(ngModel)]="lastRuleValues.selectedValue" placeholder="Enter" [disabled]="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'" />
                </ng-container>
                <ng-container *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed != 'No_Value'">
                    <input *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'String'" pInputText type="text" [(ngModel)]="lastRuleValues.selectedValue" placeholder="Enter" [disabled]="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'" />
                    <!-- <input pInputText type="text" [(ngModel)]="lastRuleValues.selectedValue2" placeholder="Enter"
                        *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'"/> -->
                    <p-multiSelect *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'User'" appendTo="body" [options]="users" [(ngModel)]="lastRuleValues.selectedValue" optionLabel="name" placeholder="Select Users">
                    </p-multiSelect>
                    <!-- Country -->
                    <ng-container *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'Country'">
                        <!-- <liono-treeSelect [(ngModel)]="lastRuleValues.selectedValue" selectionMode="multiple" display="nodes" optionLabel="name"
                        selectionMode="checkbox" [options]="nodes" appendTo="body" scrollHeight="300px" [options]="allCountryList"
                        placeholder="Select Items" [filter]="true" [resetFilterOnHide]="true">
                        </liono-treeSelect> -->
                        <p-dropdown appendTo="body" [options]="allCountryList" optionLabel="name" [(ngModel)]="lastRuleValues.selectedValue" [filter]="true" [resetFilterOnHide]="true" placeholder="Select Items">
                        </p-dropdown>
                    </ng-container>
                     <!-- Country -->
                    <ng-container *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'DropdownList'">
                        <p-dropdown appendTo="body" [options]="lastRuleValues.allEnumMultiselect" optionLabel="name" [(ngModel)]="lastRuleValues.selectedValue" [filter]="true" [resetFilterOnHide]="true" placeholder="Select Item">
                        </p-dropdown>
                    </ng-container> 
                    <!-- MultiSelect -->
                    <ng-container *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'MultiSelect'">
                        <p-multiSelect appendTo="body" [options]="lastRuleValues.allEnumMultiselect" [(ngModel)]="lastRuleValues.selectedValue" optionLabel="name" [optionGroupLabel]="lastRuleValues.selectedGroupLabel" [optionGroupChildren]="lastRuleValues.selectedGroupChildren" [group]="lastRuleValues.selectedGroup" placeholder="Select Items" (onChange)="onChangeRuleFieldValue(lastRuleValues)">
                            <ng-template let-obj pTemplate="selectedItem">
                                <span pTooltip="{{obj.name}}" tooltipPosition="top">
                                    {{ (obj.name.length>40)? (obj.name | slice:0:40)+'..':(obj.name) }}
                                </span>
                            </ng-template>
                        </p-multiSelect>
                    </ng-container>
                    <!-- MultiSelectAPI -->
                    <ng-container *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'MultiSelectAPI'">
                        <p-multiSelect appendTo="body" [lazy]="true" (onFilter)="searchAutocompleteItems($event, 'Selected', null, lastRuleValues.selectedFilter)" [options]="lastRuleValues.allEnumMultiselect" [(ngModel)]="lastRuleValues.selectedValue" optionLabel="name" placeholder="Search Items">
                            <ng-template let-obj pTemplate="selectedItem">
                                <span pTooltip="{{obj.name}}" tooltipPosition="top">
                                    {{ (obj.name.length>40)? (obj.name | slice:0:40)+'..':(obj.name) }}
                                </span>
                            </ng-template>
                        </p-multiSelect>
                    </ng-container>
                    <!-- TreeSelect -->
                    <ng-container *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'TreeSelect' && lastRuleValues.selectedFilter?.field?.toLowerCase()=='territoryname'">
                        <liono-treeSelect [(ngModel)]="lastRuleValues.selectedValue" [options]="territory" appendTo="body" placeholder="Select Territory" (onNodeExpand)="onNodeExpand($event)" (onNodeSelect)="onChangeAssign($event)" [filter]="true" [filterInputAutoFocus]="true" selectionMode="single">
                        </liono-treeSelect>
                    </ng-container>
                    <ng-container *ngIf="lastRuleValues.selectedFilter?.valueDataType == 'TreeSelect' && lastRuleValues.selectedFilter?.field?.toLowerCase()!='territoryname'">
                        <liono-treeSelect [(ngModel)]="lastRuleValues.selectedValue" [options]="lastRuleValues.treeSelectData" appendTo="body" placeholder="Select Item" [filter]="true" [metaKeySelection]="false" selectionMode="multiple" display="comma">
                        </liono-treeSelect>
                    </ng-container>
                </ng-container>
            </ng-container>
            <!-- DateTime -->
            <ng-container *ngIf="lastRuleValues.selectedFilter?.fieldDataType == 'DateTime'">
                <p-dropdown *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value' && lastRuleValues.selectedDataTypeWithOperator?.Operator == 'Is'" [options]="dateTimeOperatorValue" id="code" [style]="{'width':'100%'}" (onChange)="dateTimeOperatorValueChange()"
                    [(ngModel)]="lastRuleValues.selectedValue2" optionLabel="label" appendTo="body" placeholder="Select Value">
                </p-dropdown>
                <p-calendar *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed != 'Between_Value' &&
                    (lastRuleValues.selectedDataTypeWithOperator?.Operator != 'Is' || (lastRuleValues.selectedDataTypeWithOperator?.Operator == 'Is' && lastRuleValues.selectedValue2?.code == 'custom'))" appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                    dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{standalone: true}" [(ngModel)]="lastRuleValues.selectedValue" [disabled]="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'No_Value'">
                </p-calendar>
                <p-calendar *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'" appendTo="body" selectionMode="range" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy to mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"
                    [ngModelOptions]="{standalone: true}" [(ngModel)]="lastRuleValues.selectedValue">
                </p-calendar>
            </ng-container>
            <!-- Time -->
            <ng-container *ngIf="lastRuleValues.selectedFilter?.fieldDataType == 'Time'">
                <div class="p-d-flex p-ai-center">
                    <input pInputText type="time" [(ngModel)]="lastRuleValues.selectedValue" class="w-100">
                    <input *ngIf="lastRuleValues.selectedDataTypeWithOperator?.NoOfValuesToBePassed == 'Between_Value'"  pInputText type="time" [(ngModel)]="lastRuleValues.selectedValue2" class="w-100">
                </div>
            </ng-container>
            <!-- When filter not selected -->
            <ng-container *ngIf="!lastRuleValues?.selectedFilter?.fieldDataType">
                <input pInputText type="text" placeholder="Enter" [disabled]="true" />
            </ng-container>
            <small *ngIf="lastRuleValues?.ruleErrorMsg" style="color: red;" [ngClass]="{'main-module-rule-error': isMainModule }" class="saved-search-rule-error">{{lastRuleValues?.ruleErrorMsg}}</small>
        </div>
        <div *ngIf="!editRule && lastRuleValues?.selectedFilter" class="p-col-12 p-lg-1 p-mt-5">
            <div title="Add Rule" [ngClass]="{'saved-search-disabled': (ruleList?.length + ruleData?.length) >= 10 || !(lastRuleValues.selectedValue || lastRuleValues.selectedValue2)}" class="btnBars p-mr-0" (click)="addRuleList()" style="float: right;">
                <i class="pi pi-plus"></i>
            </div>
        </div>
    </div>
</div>

<!-- Address/Lat/Lng Modal -->
<p-dialog header="Select Address & Radius" [(visible)]="displayAddressSelect" [style]="{width: '550px'}" [modal]="true" [baseZIndex]="10000" [blockScroll]="true">
    <div class="card" *ngIf="displayAddressSelect">
        <div class="p-grid">
            <div class="p-col-12 p-lg-6">
                <label>Location</label>
                <lion-gm-place-autocomplete [formattedAddress]="selectedLatLng?.address" (onRemoveAddress)="onRemoveAddressLocation($event)" (onAddressChange)="onAddressChanged($event, lastRuleValues.selectedValue)" (onSettingAddrress)="onAddressBlur($event)">
                </lion-gm-place-autocomplete>
            </div>
            <div class="p-col-12 p-lg-4">
                <label>Radius</label>
                <input pInputText type="number" [(ngModel)]="selectedLatLng.radius" placeholder="In miles">
            </div>
            <!-- <div class="p-col-12 p-lg-2">
                <label></label>
                <span>Miles</span>
            </div> -->
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayAddressSelect=false;" label="Cancel" class="p-button-secondary"></button>
        <button type="submit" pButton label="Save" (click)="saveAddressSelect()"></button>
    </p-footer>
</p-dialog>
